export default "__VITE_ASSET__a19f6955__"